import Form from "./Form";

export default function App() {
  return (
    <div>
      <Form />
    </div>
  );
}
